import styled from 'styled-components'
import Button from 'components/Button'

export const CategoryContainer = styled.div`
  position: relative;
  display: grid;
  padding: 0px;
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }
`

export const CategoryHeaderMenu = styled.div`
  @media screen and (min-width: 1100px) {
    background-color: ${props => props.theme.color.lightGrey2};
    padding: 15px 21px 18px 21px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 108px;
    position: relative;
  }
`

export const NoProductFoundDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  background: #ff670045;
  border-radius: 33px;
  font-size: 16px;
`

export const TopItemTitle = styled.h4`
  font-size: 14px;
  color: ${props => props.theme.color.orange};
  padding: 14px 16px;
  border-radius: 23px;
  border: 1px solid ${props => props.theme.color.orange};
  max-width: 142px;
`

export const CategoryHeaderButton = styled(Button)`

  @media screen and (min-width: 1100px) {
    display: flex;
    align-items: center;
    color: ${props => props.theme.color.blue1};
    font-size: 15px;
    font-family: ${props => props.theme.font.family.medium};
    svg {
      margin-right: 13px;
    }
  }

`

export const CategoryHeaderList = styled.ul`
  @media screen and (min-width: 1100px) {
    list-style: none;
    li {
      float: left;
      display: flex;
      align-items: center;

      img {
        width: 15px;
        height: 15px;
        margin-right: 8px;
      }

      &:not(:first-child) {
        margin-left: 45px;
      }

      a {
        font-size: ${props => props.theme.font.size.sm};
        color: ${props => props.theme.color.black1};
        text-decoration: none;
      }
    }
  }

`

export const CategoryMainContent = styled.div`
  margin-top: 0px;

  @media screen and (min-width: 1100px) {
    margin-top: 34px;
    display: grid;
    grid-template-columns: 2fr 9fr;
    grid-column-gap: 28px;
  }

`

export const ProductGridSelects = styled.div`
  display: flex;
  column-gap: 8px;
`

export const FilterBlock = styled.div`
  display: grid;
  grid-row-gap: 20px;

  h3 {
    font-size: 15px;
    font-family: ${props => props.theme.font.family.bold};
    color: ${props => props.theme.color.black2};
    margin: 0;
  }

  span {
    font-size: ${props => props.theme.font.size.sm};
    color: ${props => props.theme.color.black4};
  }

  p {
    font-size: 13px;
    text-decoration: none;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 10px;
    align-items: center;
    color: ${props => props.theme.color.black2};
    cursor: pointer;
  }

  @media screen and (min-width: 1100px) {


  }

`

export const ClearFilterButton = styled(Button)`
  color: ${props => props.theme.color.red2};
  font-size: ${props => props.theme.font.size.sm};
  font-family: ${props => props.theme.font.family.medium};
  text-decoration: underline;
  justify-self: start;
  @media screen and (min-width: 1100px) {

  }
`

export const RangeInputs = styled.div`
  display: grid;
  grid-row-gap: 20px;
  @media screen and (min-width: 1100px) {

  }
`

export const CheckboxInputs = styled.div`
  display: grid;
  max-height: 140px;
  grid-row-gap: 18px;
  overflow: hidden;
  transition: .3s;

  &.active {
    overflow-y: auto;
    max-height: 300px;
  }

  @media screen and (min-width: 1100px) {

  }
`

export const RadioInputs = styled.div`
  display: grid;
  grid-row-gap: 22px;
  @media screen and (min-width: 1100px) {

  }
`

export const CategoryFilter = styled.div`
  display: grid;
  grid-row-gap: 40px;
  @media screen and (min-width: 1100px) {

  }
`

export const TopCategoryItemCont = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 29px;
  grid-row-gap: 30px;
  margin-top: 30px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const CategoryFilterContainer = styled.div`
  /* display: grid; */
  /* grid-row-gap: 40px; */
  /* grid-template-rows: auto 1fr; */

  /* @media screen and (min-width: 1100px) {
    padding-bottom: 40px;
  } */
`

export const CategoryContent = styled.div`
  padding-bottom: 47px;
  position: relative;
`

export const CategorySale = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 34px;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(4,  minmax(0, 1fr));
  }
  @media screen and (min-width: 1500px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`

export const CategorySliderContainer = styled.div`
  margin-top: 34px;
  grid-column-gap: 29px;
  grid-row-gap: 20px;
`


export const FilterModalContent = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 150px;

`

export const CategoryFilterSection = styled.div`
  margin-left: 0;
  display: flex;
  justify-content: space-between;
  padding: 11px 14px 0 14px;
  align-items: center;


  button {
    height: 36px;
    border-color: ${props => props.theme.color.grey1};
    display: flex;
    align-items: center;
    gap: 13px;
  }

  .custom-select__control {
    max-width: 155px;
  }

  .modal-content {
    width: 100%;
    height: 100vh;
    top: 0px;

    .modal-body {
      padding-right: 0px;
    }
  }

  .custom-select__single-value {
    font-size: 14px !important;
    padding-left: 12px;
  }
  
`
export const FilterTags = styled.div`
  width: 100vw;
  display: flex;
  overflow: scroll;
  padding: 0 14px
  


`
export const FilterTag = styled.a`
  cursor: pointer;
  background-color: ${props => props.theme.color.red2};
  padding: 5px 10px;
  border-radius: 15px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  p {
    color: white;
    font-family: ${props => props.theme.font.family.medium};
    font-size: 12px;

  }

  svg {
    margin-left: 4px;
  }

  &:not(:first-child) {
    margin-left: 10px;
  }

`

export const FilterModalButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 12px 19px 14px 16px;
  box-shadow: 0 -5px 6px 0 rgba(0, 0, 0, 0.03);
  background-color: #ffffff;
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 99;
`

export const FilterModalTopButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 12px 19px 0 16px;
  box-shadow: 0 -5px 6px 0 rgba(0, 0, 0, 0.03);
  background-color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
`
